<template>
    <div class="announcement">
      <transition name="fade">
        <div class="pop-body" v-if="toggle">
          <div class="main-title p-3 d-flex justify-content-between">
            <h3 class="p-2" style="color:#fff;font-weight:bold">考場資訊</h3>
          </div>
          <div class="content-layout" v-if="!announcementData">
            <div class="content-scroll" v-for="(item, index) in announcement" :key=index>
              <div class="content-box">
                <!-- <span style="float: right;">成績: {{item.score!==null ? item.score: '尚未作答'}}</span> -->
                <h4 class="title">考試名稱: {{item.name}}</h4>
                <div class="mb-1 mx-2">
                  <span v-if="item.is_repeatable" class="badge badge-success">重複錄音</span>
                  <span v-else class="badge badge-danger">不可重複</span>
                </div>
                <div class="pb-2 px-2">
                  <p>老師名稱: {{item.creator.name}}</p>
                </div>
                <div style="text-align:center">
                  <button type="button" @click="openAnnouncement(item)" class="btn btn-dark">了解更多</button>
                </div>
              </div>
            </div>
          </div>
          <div class="content-layout" v-else>
            <div class="content-scroll">
              <div class="content-box d-flex flex-column" style="min-height:300px">
                <h3 class="px-2 mb-0 title">{{announcementData.name}}</h3>
                <div class="px-2 pb-2 mb-0">老師:{{ announcementData.creator.name }}</div>
                <hr style="border: 1px solid red; width:90%">
                <div v-if="announcementData.note" class="content px-2" v-html="announcementData.note">
                </div>
                <div v-else class="content px-2">
                  無備註
                </div>
                <div style="text-align:center">
                  <button type="button" @click="goExam(announcementData)" class="btn mx-2 btn-dark">考試</button>
                  <button type="button" @click="back()" class="btn mx-2 btn-dark">返回</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <div v-if="announcement && announcement.length > 0" class="bubble pointer" @click="toggle = !toggle">
        <div v-if="announcement.length>0" class="circle">
          {{announcement.length}}
        </div>
        <img class="p-3" v-if="!toggle" style="width:100%" src="../assets/image/pic/btn_news_in_on.png" alt="">
        <img class="p-3" v-else style="width:100%" src="../assets/image/pic/btn_news_in_off.png" alt="">
      </div>
    </div>
  </template>

  <script>
  import api from '../store/api'
  export default {
    name: 'Announcement',
    data () {
      return {
        toggle: false,
        announcement: null,
        announcementData: null,
        unread_count: 0
      }
    },
    computed: {
      now () {
        return moment().format("YYYY-MM-DD HH:mm");
      }
    },
    mounted () {
      this.getAnnouncement()
    },
    methods: {
      async getAnnouncement () {
        const options = { headers: {'showLoading': false }}
        const { data } = await api.get(`liveabc/rooms?status=in_progress`)
        this.announcement = data.data
      },
      async openAnnouncement (el) {
        this.announcementData = el
      },
      back () {
        this.announcementData = null
        this.getAnnouncement()
      },
      goExam (el) {
        this.$router.push({ name: 'Oral-exam', params:{ examId: el.id, repeatable: el.is_repeatable ? 1 : 0 }})
      }
    }
  }
  </script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped lang="scss">
  @import "../assets/styles/color.scss";
    .announcement {
      z-index:5050;
      position: fixed;
      bottom: 0;
      right: 0;
      .pop-body {
        width:380px;
        height:500px;
        background:#fff;
        border: solid 1px #ccc;
        text-align:left;
        position:relative;
        border-radius: 10px;
        box-shadow: 0px 0px 5px  rgb(109, 109, 109);
        .title {
          font-size: 1.5rem;
          font-weight: 600;
        }
        .main-title {
          height:100px;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          background:red;
        }
        .content-layout {
          height: 420px;
          overflow: auto;
          position: absolute;
          top:10%;
          padding: 10px;
          margin: 20px 0 0 0;
          .content-scroll {
            padding: 0px 30px;
            .content-box {
              box-shadow: 0px 0px 10px  rgb(109, 109, 109);
              border: solid #ccc 1px;
              border-radius: 5px;
              width: 350px;
              overflow: auto;
              background: #fff;
              margin: 0px 0px 20px -15px;
              padding: 10px;
              .content {
                min-height: 200px
              }
            }
          }
        }
      }
      .bubble {
        margin: 10px;
        float: right;
        width: 60px;
        height: 60px;
        background: #E83015;
        border-radius: 50%;
        box-shadow: 2px 2px 5px  rgb(83, 83, 83);
      }
    }
    .circle {
      right: 5px;
      font-size: .8rem;
      position: absolute;
      border-radius: 50%;
      border: .5px solid #ccc;
      width: 20px;
      height: 20px;
      color: red;
      background: #fff;
    }
    .read-btn {
      color: #fff;
      text-decoration: underline;
    }
    .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }
  </style>
